(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Tracked separately from the `disabled` attribute itself as a backstop —
  // see the capture-phase click listener below.
  var lastMeetsMinimum = true;

  function setCheckoutEnabled(enabled) {
    lastMeetsMinimum = enabled;
    document.querySelectorAll('[data-rmin-checkout-btn]').forEach(function (btn) {
      btn.disabled = !enabled;
    });
    document.querySelectorAll('[data-rmin-express]').forEach(function (wrap) {
      wrap.style.display = enabled ? '' : 'none';
    });
  }

  // Belt-and-suspenders: the `disabled` attribute above should already stop
  // this, but a capture-phase listener catches it too in case something
  // else (a fresh server-rendered cart drawer replacing the button before
  // refresh() re-runs, another script, etc.) ever lets a click through
  // while under the minimum.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rmin-checkout-btn]');
    if (btn && !lastMeetsMinimum) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // Whole-screen celebratory fall, ~3s — plain divs animated via CSS (see
  // reset-floating-minimum-bar.liquid) rather than pulling in a confetti
  // library for one moment. Pieces start above the viewport at random X
  // positions across its full width and fall past the bottom, instead of
  // bursting outward from one small corner badge.
  function launchConfetti() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#E7A145', '#42684E', '#1D4A78', '#d64545', '#ffffff'];
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    for (var i = 0; i < 120; i++) {
      var piece = document.createElement('div');
      piece.className = 'rfloatmin-confetti-piece';
      piece.style.left = (Math.random() * vw) + 'px';
      piece.style.top = (-20 - Math.random() * vh * 0.3) + 'px';
      piece.style.background = colors[i % colors.length];
      piece.style.animationDelay = (Math.random() * 0.6) + 's';
      piece.style.setProperty('--dx', (Math.random() * 200 - 100) + 'px');
      piece.style.setProperty('--dy', (vh + 60) + 'px');
      piece.style.setProperty('--rot', (Math.random() * 900 - 450) + 'deg');
      document.body.appendChild(piece);
      piece.addEventListener('animationend', function () { this.remove(); });
    }
  }

  function updateRoot(root, cartTotal, exempt, mismatch) {
    var minCents = parseInt(root.dataset.rminMin, 10) || 0;
    var freeCents = parseInt(root.dataset.rminFree, 10) || 0;

    var minRow = root.querySelector('[data-rmin-min-row]');
    var minFill = root.querySelector('[data-rmin-min-fill]');
    var minText = root.querySelector('[data-rmin-min-text]');
    var freeRow = root.querySelector('[data-rmin-free-row]');
    var freeFill = root.querySelector('[data-rmin-free-fill]');
    var freeText = root.querySelector('[data-rmin-free-text]');
    var checkoutCta = root.querySelector('[data-rmin-checkout-cta]');

    // `exempt` (decided by the caller in refresh(), see computeMinimumInput)
    // is true only when there's no separate à la carte delivery to worry
    // about, or when that à la carte delivery's own date genuinely matches
    // one of the cart's Goal Plan lines' real cycle dates — i.e. the truck
    // is already going out that exact day regardless. `cartTotal` passed in
    // when NOT exempt is the à la carte-only subtotal, never the whole
    // cart's total — using the whole total would let a tiny mismatched-day
    // item trivially clear $150 off an unrelated Goal Plan's own price,
    // which was the entire problem this exists to prevent. Confirmed
    // directly with the owner.
    if (exempt) {
      if (minRow) minRow.hidden = true;
      if (freeRow) freeRow.hidden = true;
      if (checkoutCta) checkoutCta.disabled = false;
      return true;
    }

    var meetsMinimum = cartTotal >= minCents;
    // Stays visible either way now — just disabled (greyed out, styled via
    // :disabled in reset-floating-minimum-bar.liquid) under the minimum,
    // instead of disappearing outright.
    if (checkoutCta) checkoutCta.disabled = !meetsMinimum;

    // Celebrate the exact moment the cart crosses into free delivery — only
    // from the floating bar (there's just one of it, always on screen,
    // avoiding a duplicate burst from the cart drawer/page's own copy of
    // this same markup) and only on a genuine transition, not on page load
    // when the cart already qualifies.
    if (root.hasAttribute('data-rmin-floating') && freeCents > 0) {
      var isFree = meetsMinimum && cartTotal >= freeCents;
      var previouslyKnown = root.dataset.rminWasFree !== undefined;
      var wasFree = root.dataset.rminWasFree === 'true';
      if (isFree && previouslyKnown && !wasFree) launchConfetti();
      root.dataset.rminWasFree = isFree ? 'true' : 'false';
    }

    if (!meetsMinimum) {
      if (minRow) minRow.hidden = false;
      if (minFill) minFill.style.width = Math.min(100, (cartTotal / minCents) * 100) + '%';
      if (minText) {
        // Writing .textContent unconditionally is itself a DOM mutation —
        // this file's own MutationObserver below watches the whole page
        // (subtree: true, because Shopify's cart drawer replaces this
        // markup outright on changes) and reacts to exactly that kind of
        // mutation by calling refresh() again, which calls this function
        // again. Setting the same text every call kept that loop running
        // forever instead of settling — confirmed live as part of a
        // runaway cycle that flooded /cart.js until Shopify rate-limited
        // it. Only writing when the value actually changed stops it once
        // the text is already correct.
        //
        // `mismatch` (true only when there's a Goal Plan in the cart whose
        // delivery date genuinely doesn't match the à la carte item's own
        // date) gets its own, more specific message — a first-time
        // customer who adds one à la carte item then a Goal Plan for a
        // different delivery day otherwise just sees "$X more to reach
        // minimum order" with no clue that matching the two dates would
        // skip the requirement entirely instead of spending more.
        var minTextValue = mismatch
          ? 'Your à la carte order and Goal Plan deliver on different days. Add ' + money(minCents - cartTotal) + ' more to your à la carte order to reach the ' + money(minCents) + ' minimum, or change your à la carte delivery date to match your Goal Plan to skip it.'
          : money(minCents - cartTotal) + ' more to reach minimum order';
        if (minText.textContent !== minTextValue) minText.textContent = minTextValue;
      }
    } else if (minRow) {
      minRow.hidden = true;
    }

    // free-delivery progress only appears once the minimum order has been
    // met. Previously hid itself entirely once cartTotal reached freeCents —
    // now stays up with a celebratory "unlocked" message instead, since
    // disappearing read as the bar just vanishing rather than confirming
    // free delivery was actually earned.
    if (meetsMinimum && freeCents > 0 && cartTotal < freeCents) {
      if (freeRow) freeRow.hidden = false;
      if (freeFill) freeFill.style.width = Math.min(100, (cartTotal / freeCents) * 100) + '%';
      if (freeText) {
        var freeTextValue = 'Spend ' + money(freeCents - cartTotal) + ' more for free delivery';
        if (freeText.textContent !== freeTextValue) freeText.textContent = freeTextValue;
      }
    } else if (meetsMinimum && freeCents > 0 && cartTotal >= freeCents) {
      if (freeRow) freeRow.hidden = false;
      if (freeFill) freeFill.style.width = '100%';
      if (freeText) {
        var freeUnlockedValue = 'You got free delivery!';
        if (freeText.textContent !== freeUnlockedValue) freeText.textContent = freeUnlockedValue;
      }
    } else if (freeRow) {
      freeRow.hidden = true;
    }

    return meetsMinimum;
  }

  // à la carte's own delivery day is stored as a plain human label on the
  // cart ("Wednesday, 7 Oct" — see reset-delivery-calendar.js's saveToCart),
  // not an ISO date — no year, either. Reconstructs one using the current
  // year, rolling to next year if that lands more than ~2 months in the
  // past (delivery dates are always near-future, never historical, so a
  // "past" result only ever means the label is for early next year).
  function parseAlaCarteDeliveryDate(cart) {
    var label = cart.attributes && cart.attributes['Delivery Date'];
    if (!label) return null;
    var commaIndex = label.indexOf(',');
    if (commaIndex === -1) return null;
    var dayMonth = label.slice(commaIndex + 1).trim();
    var now = new Date();
    var candidate = new Date(dayMonth + ' ' + now.getFullYear());
    if (isNaN(candidate.getTime())) return null;
    var twoMonthsMs = 60 * 24 * 60 * 60 * 1000;
    if (candidate.getTime() < now.getTime() - twoMonthsMs) {
      candidate = new Date(dayMonth + ' ' + (now.getFullYear() + 1));
    }
    var mm = String(candidate.getMonth() + 1);
    if (mm.length < 2) mm = '0' + mm;
    var dd = String(candidate.getDate());
    if (dd.length < 2) dd = '0' + dd;
    return candidate.getFullYear() + '-' + mm + '-' + dd;
  }

  // Decides what updateRoot() should actually check. backend_plan_id (set
  // on every real Goal Plan cart line — the paid line and its $0 recipe
  // lines alike, confirmed by calling the checkout API directly and
  // inspecting its real response) may be hidden from the customer with a
  // leading underscore, same convention reset-cart-plan-guard.js already
  // relies on to find a plan's own lines — checked both forms here for the
  // same reason. An earlier version of this looked for a "Plan" property
  // instead, which doesn't exist on a real backend-created line at all —
  // confirmed live as the reason the exemption never actually triggered.
  // A second, separate bug on top of that one: even once a Goal Plan was
  // correctly detected, ANY Goal Plan in the cart exempted the threshold
  // entirely — including when the à la carte item's own delivery date had
  // nothing to do with either of that plan's real cycle dates (confirmed
  // live: a Wednesday-the-7th à la carte item next to a Goal Plan whose
  // actual cycle dates were the 11th and 14th still got waved through).
  // Exemption now requires the à la carte delivery date to actually match
  // one of the Goal Plan's own cycle_date values, and when it doesn't, the
  // threshold check uses the à la carte-only subtotal — never the whole
  // cart total, which would trivially clear $150 off the Goal Plan's own
  // price regardless of whether the à la carte portion earned it.
  function computeMinimumInput(cart) {
    var items = cart.items || [];
    var hasGoalPlan = false;
    var goalPlanCycleDates = {};
    var alaCarteSubtotal = 0;

    items.forEach(function (item) {
      var props = item.properties || {};
      var planId = props.backend_plan_id || props._backend_plan_id;
      if (planId) {
        hasGoalPlan = true;
        var cycleDate = props.cycle_date || props._cycle_date;
        if (cycleDate) goalPlanCycleDates[cycleDate] = true;
      } else {
        alaCarteSubtotal += item.line_price || 0;
      }
    });

    if (!hasGoalPlan) return { amount: cart.total_price, exempt: false, mismatch: false };
    if (alaCarteSubtotal <= 0) return { amount: 0, exempt: true, mismatch: false };

    var alaCarteDate = parseAlaCarteDeliveryDate(cart);
    var sameDayAsGoalPlan = !!(alaCarteDate && goalPlanCycleDates[alaCarteDate]);
    return { amount: alaCarteSubtotal, exempt: sameDayAsGoalPlan, mismatch: !sameDayAsGoalPlan };
  }

  // Shared with reset-goal-plan.js so its own "Continue to Checkout" button
  // (which adds straight to cart via a separate backend call, never passing
  // through updateRoot()/[data-rmin-checkout-btn] at all) can be gated by
  // this exact same rule instead of silently bypassing it — confirmed live
  // that without this, adding an under-minimum/mismatched-date à la carte
  // item first and then a Goal Plan for a different delivery day let the
  // Goal Plan's own button add to cart and jump straight to checkout with
  // no block and no explanation at all.
  function getMinCents() {
    var anyRoot = document.querySelector('[data-rmin]');
    return (anyRoot && parseInt(anyRoot.dataset.rminMin, 10)) || 7500;
  }
  window.ResetCartMinimum = {
    computeMinimumInput: computeMinimumInput,
    isCheckoutBlocked: function (cart) {
      var input = computeMinimumInput(cart);
      return !input.exempt && input.amount < getMinCents();
    }
  };

  function refresh() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-rmin]'));
    if (!roots.length) return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var input = computeMinimumInput(cart);
        var meetsMinimum = true;
        roots.forEach(function (root) {
          if (!updateRoot(root, input.amount, input.exempt, input.mismatch)) meetsMinimum = false;

          // the site-wide floating bar (unlike the cart drawer/page version)
          // has nothing else around it, so hide it entirely once there's
          // nothing useful left to show — an empty cart — instead of leaving
          // a blank strip on screen. It stays visible past the free-delivery
          // threshold now too, since the checkout button still belongs there.
          if (root.hasAttribute('data-rmin-floating')) {
            root.hidden = cart.item_count === 0;
            // A plain class, not CSS :has() — reset-floating-minimum-bar.liquid
            // used to gate its page-content-reservation rules on
            // `body:has([data-rmin-floating]:not([hidden]))`, which quietly does
            // nothing at all (not an error, just never matches) in any browser
            // without :has() support — genuinely new enough (Firefox only got
            // it in late 2023) that this was confirmed live as the actual
            // reason two separate, individually-correct positioning fixes had
            // zero visible effect. This class does the identical job but
            // works everywhere.
            document.body.classList.toggle('has-rfloatmin', !root.hidden);
          }
        });
        setCheckoutEnabled(meetsMinimum);
      })
      .catch(function () {});
  }

  refresh();

  // Position the floating card just below the header's actual on-screen
  // edge, not a static header-height assumption — the header sits below
  // the cutoff-countdown announcement bar until scrolled past it (then
  // pins to the top), so a fixed offset alone would overlap the
  // announcement bar while unscrolled.
  var floatingBar = document.querySelector('[data-rmin-floating]');
  var headerEl = document.querySelector('header-component');

  // Relocate to a direct child of <body> before doing anything else. The
  // theme's own section wrappers (including whatever wraps the sticky
  // header) can establish a CSS containing block for position: absolute —
  // same issue documented elsewhere in this theme for position: fixed —
  // which would make this track that ancestor's box (and its sticky
  // behaviour) instead of the actual page, exactly the "won't scroll away"
  // symptom seen live. <body> here has no position/transform of its own,
  // so this guarantees a clean, document-relative containing block.
  if (floatingBar && floatingBar.parentNode !== document.body) {
    document.body.appendChild(floatingBar);
  }

  // this button lives in the floating bar's own (never server-re-rendered)
  // markup, so it's safe to wire up once here rather than re-binding on
  // every refresh() call like the cart drawer's own elements need to be
  var floatingCheckoutCta = floatingBar ? floatingBar.querySelector('[data-rmin-checkout-cta]') : null;
  if (floatingCheckoutCta) {
    floatingCheckoutCta.addEventListener('click', function () {
      // Same backstop as the capture-phase listener above — this button is
      // only ever supposed to be visible once the minimum is met, but check
      // the live state again here too rather than trusting visibility alone.
      if (!lastMeetsMinimum) return;
      window.location.href = '/checkout';
    });
  }

  if (floatingBar && headerEl) {
    var positionScheduled = false;
    // Now that the card is position: absolute (scrolls away with the page
    // instead of staying pinned to the viewport the whole time), its `top`
    // needs to be a document-relative offset, not the header's raw
    // viewport-relative rect — add the current scroll position to convert
    // one into the other. Only recomputed on load/resize/header-size-change
    // now, not on every scroll — it isn't chasing the viewport anymore.
    var positionFloatingBar = function () {
      positionScheduled = false;
      var bottom = headerEl.getBoundingClientRect().bottom + window.scrollY;
      floatingBar.style.top = Math.max(bottom, 0) + 10 + 'px';
    };
    var schedulePositionFloatingBar = function () {
      if (positionScheduled) return;
      positionScheduled = true;
      requestAnimationFrame(positionFloatingBar);
    };
    positionFloatingBar();
    window.addEventListener('resize', schedulePositionFloatingBar);
    if (window.ResizeObserver) {
      new ResizeObserver(schedulePositionFloatingBar).observe(headerEl);
    }

    // Mobile-only in effect: toggling this class does nothing on desktop
    // since the CSS rule that reacts to it only exists inside the mobile
    // media query in reset-floating-minimum-bar.liquid, so no breakpoint
    // check is needed here. At rest the card sits below both the header
    // and the cutoff-countdown bar above it (the starting position set by
    // the mobile CSS); the instant any real scrolling happens, it should
    // snap up flush against the header instead, with no lingering gap
    // sized for the countdown bar that's since scrolled out of view. A
    // small threshold (not `> 0`) avoids flapping the class on the kind of
    // sub-pixel scroll jitter some mobile browsers fire on load.
    //
    // The mobile content-reservation padding (how far down .rmenu__inner
    // needs to start so nothing ever renders under the card) used to be a
    // guessed static px value computed from --header-height/
    // --header-group-height — confirmed live as unreliable: those variables
    // apparently don't hold what the fallback values assumed, so the guess
    // was off by enough to keep overlapping real content in both the
    // at-rest and pinned states. This instead reads the card's own actual
    // on-screen bottom edge directly (getBoundingClientRect().bottom is
    // already viewport-relative — exactly right for a position: fixed
    // element, no unit conversion needed) and reserves exactly that much,
    // however each state actually renders — nothing left to guess.
    var pinScheduled = false;
    var updateFloatingBarLayout = function () {
      pinScheduled = false;
      floatingBar.classList.toggle('is-pinned', window.scrollY > 12);
      var rect = floatingBar.getBoundingClientRect();
      document.body.style.setProperty('--rfloatmin-mobile-reserve', Math.max(0, rect.bottom + 14) + 'px');
    };
    var scheduleFloatingBarLayout = function () {
      if (pinScheduled) return;
      pinScheduled = true;
      requestAnimationFrame(updateFloatingBarLayout);
    };
    updateFloatingBarLayout();
    window.addEventListener('scroll', scheduleFloatingBarLayout, { passive: true });
    window.addEventListener('resize', scheduleFloatingBarLayout);

    // Since the card floats fixed on top of the page instead of pushing
    // content down, the heading right below it needs its own reserved
    // top space (see the `.has-rfloatmin` rules in
    // reset-floating-minimum-bar.liquid) so text never renders underneath
    // it. Track the card's real height — it changes once the free-delivery
    // row appears — via a CSS var that rule reads. (Desktop-only concern in
    // practice now — mobile uses the measured bottom-edge reservation
    // above instead, which reacts to the card's real on-screen position
    // rather than just its height.)
    if (window.ResizeObserver) {
      var setFloatingBarHeightVar = function () {
        document.body.style.setProperty('--rfloatmin-height', floatingBar.hidden ? '0px' : floatingBar.offsetHeight + 'px');
        scheduleFloatingBarLayout();
      };
      new ResizeObserver(setFloatingBarHeightVar).observe(floatingBar);
    }
  }

  // Shopify's cart drawer re-renders its own markup from the server on cart
  // changes, replacing our DOM nodes outright — so we re-query fresh on every
  // refresh (above) rather than caching root elements once, and re-scan
  // whenever the page's markup changes at all, not just via cart events.
  //
  // A minimum real-time gap between actual runs, on top of the rAF
  // coalescing, is a second layer against the same class of runaway loop
  // found (and fixed at the source) in reset-delivery-calendar.js's own
  // near-identical observer: refresh() calling fetch('/cart.js') on every
  // single DOM mutation, if anything here ever starts mutating the page in
  // a way this same observer picks up, would flood the cart endpoint the
  // same way that one did until Shopify started returning 429s.
  if (window.MutationObserver) {
    var scheduled = false;
    var lastRefreshRun = 0;
    var MIN_REFRESH_INTERVAL_MS = 1000;
    var mo = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        if (Date.now() - lastRefreshRun < MIN_REFRESH_INTERVAL_MS) return;
        lastRefreshRun = Date.now();
        refresh();
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:cart:lines-update', refresh);
  document.addEventListener('shopify:cart:update', refresh);
})();
